import { UnitRelationships } from './unit-relationships';
import { UnitAttributes } from './unit-attributes';

export interface Unit {
  type: 'units';
  id: string;
  attributes: UnitAttributes
  relationships: UnitRelationships
}

export const unitsAttributes = [
  "asset_ref_uuid",
  "normalized_address",
  "type_of_use",
  "area",
  "floor_number",
  "tenant_name",
  "lease_start_date",
  "lease_end_date",
  "walt",
  "rent_monthly",
  "term_service_charge",
  "country_code",
  "longitude",
  "latitude",
  "measured_by",
  "currency_code",
  "currency_exchange_rates",
  "rentroll_date",
  "source_portfolio_ref_id",
  "source_portfolio_name",
  "source_unit_ref_id",
  "source_asset_ref_id",
  "source_tenant_ref_id",
  "source_type_of_use",
  "type_of_use_2",
  "num_rooms",
  "part_of_building",
  "floor_number",
  "floor_location",
  "rented_status",
  "rented_status_terminated",
  "rented_status_termination_effective_date",
  "rent_vat",
  "rent_free_start_date",
  "rent_free_end_date",
  "rent_reduction",
  "rent_reduction_start_date",
  "rent_reduction_end_date",
  "term_opex",
  "term_heatex",
  "arrear_amount",
  "term_other_service_charges",
  "has_tenant"
]
